import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyCheckOutTime: "",
  propertyLateCheckOutTime: "",
  propertyCheckInTime: "",
  propertyEarlyCheckInTime: "",
};

const propertySlice = createSlice({
  name: "property",
  initialState: initialState,
  reducers: {
    setPropertyCheckInTime: (state, action) => {
      state.propertyCheckInTime = action.payload;
    },
    setPropertyEarlyCheckInTime: (state, action) => {
      state.propertyCheckInTime = action.payload;
    },
    setPropertyCheckOutTime: (state, action) => {
      state.propertyCheckInTime = action.payload;
    },
    setPropertyLateCheckOutTime: (state, action) => {
      state.propertyCheckInTime = action.payload;
    },
  },
});

export const {
  setPropertyCheckInTime,
  setPropertyEarlyCheckInTime,
  setPropertyCheckOutTime,
  setPropertyLateCheckOutTime,
} = propertySlice.actions;
export default propertySlice.reducer;
